<template>
  <div class="price-wrap">
    <div class="price-inner">
      <h2>PBSD 专业版价格</h2>
      <h3>Pricing of Professional PBSD</h3>
      <!-- <p class="tip">试用期内免费开放所有功能，提供无偿技术支持</p> -->
      <!-- <p class="old-price"></p> -->
      <!-- <button class="pr-btn" @click="download">下载 PBSD 1.0</button> -->
      <Article :content="price"/>
      <button class="pr-btn" @click="permissionToContrast">查看权限对比</button>
    </div>
  </div>
</template>
<script>
import ENV from '@/config/env.config'
import Article from '@/components/Article_1.vue'
import price from '@/md/price.md'

export default {
   components: {
    Article
  },
  data() {
    return {
      price
    }
  },
  name: 'price',
  methods: {
    pay() {
      this.$router.push({ path: '/pay/' })
    },
    download() {
      window.location.href = ENV.wwwURL + this.$store.getters.downloadUrl
    },
    permissionToContrast() {
       //alert('链接待添加！')
       window.open('http://server.wwforu.com//PBSD价格公告.pdf')
    }
  }
}
</script>

<style lang="less" scoped>
.price-wrap {
  background: #2a59c4;
  //background-image: url('../assets/bg2.png');
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
  background-attachment: fixed;
  font-family: "Microsoft YaHei";
  .price-inner {
    max-width: 1024px;
    margin: 0 auto;
    text-align: center;
    color: #fff;
    padding: 40px 0px;
    h2 {
      font-size: 30px;
      font-weight: 600;
      line-height: 42px;
      margin-bottom: 4px;
      margin-top: 8px;
    }
    h3 {
      font-size: 19px;
      line-height: 26px;
      margin-bottom: 25px;
    }
    .tip {
      font-size: 30px;
      font-weight: 600;
      line-height: 44px;
      margin-bottom: 30px;
    }
    .old-price {
      text-decoration: line-through;
      font-size: 20px;
      line-height: 30px;
      margin-bottom: 10px;
    }
  }
}
.pr-btn {
  padding: 10px 40px;
  font-size: 20px;
  font-weight: 600;
   font-family: "Microsoft YaHei";
}
@media screen and (max-width: 990px) {
  .price-wrap {
    .price-inner {
      // h2 {
      //   font-size: 30px;
      //   line-height: 42px;
      //   margin-bottom: 4px;
      //   margin-top: 8px;
      // }
      // h3 {
      //   font-size: 19px;
      //   line-height: 26px;
      // }
      .tip {
        font-size: 20px;
        line-height: 28px;
      }
      .old-price {
        font-size: 16px;
        line-height: 18px;
      }
    }
  }
}
</style>